import "./member.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { fetchMembershipData } from "../../api/membership.api";
import { useAuth } from "../../context/AuthContext";

const MembershipPage = () => {
  const navigate = useNavigate();
  const {
    isAuthenticated,
    setShowLoginModal,
    setIsSignUp,
  } = useAuth();


  const [membershipPlans, setMembershipPlans] = useState([]);
  const [currentMembership, setCurrentMembership] = useState(null);
  const [loading, setLoading] = useState(true);





  const formatDuration = (days) => {
    if (!days) return "lifetime";

    if (days % 365 === 0) {
      const years = days / 365;
      return years === 1 ? "year" : `${years} years`;
    }

    if (days % 30 === 0) {
      const months = days / 30;
      return months === 1 ? "month" : `${months} months`;
    }

    return `${days} days`;
  };



  useEffect(() => {
    let mounted = true;

    fetchMembershipData()
      .then((data) => {
        if (!mounted) return;


        if (data.is_member && data.current_membership) {
          setCurrentMembership({
            name: data.current_membership.membership_type.name,
            expiresOn:
              data.current_membership.end_date || "Lifetime access",
            isLifetime: !data.current_membership.end_date,
          });
        } else {
          setCurrentMembership(null);
        }



        const plans = data.membership_plans.map((plan) => ({
          id: plan.id,
          name: plan.name,
          price: `₹${plan.price}`,
          duration: plan.duration_days,
          benefits: plan.benefits || [],
          color: "#FFA726",
        }));


        setMembershipPlans(plans);
      })
      .catch(() => {
        if (!mounted) return;
        setMembershipPlans([]);
        setCurrentMembership(null);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, []);



  if (loading) return <div className="page">
    <div className="loading-wrap">
      <div className="loader" />
      <div>Loading membership details…</div>
    </div>
  </div>;

  const lifetimePlans = membershipPlans.filter(
    (plan) => !plan.duration
  );
  const visiblePlans =
    lifetimePlans.length > 0 ? lifetimePlans : membershipPlans;



  return (
    <div className="membership-page1">
      <Helmet>
        <title>Membership & Rewards | 164 Diecast Zone</title>
        <meta
          name="description"
          content="Join the 164 Diecast Zone membership program for exclusive rewards, redeem points, and member-only pricing on diecast collections."
        />
        <link rel="canonical" href="https://164diecastzone.com/membership" />
        <meta property="og:title" content="Membership & Rewards | 164 Diecast Zone" />
        <meta property="og:url" content="https://164diecastzone.com/membership" />
      </Helmet>
      <div className="breadcrumb11">
        <div className="page-container">
          <span className="breadcrumb-link">Home</span>
          <span className="highlight"> / </span>
          <span>Membership</span>
        </div>
      </div>



      <main className="main-content1 page-container">

        <section className="membership-status">
          <h1 className="title">
            MEMBERSHIP <span className="highlight">PLAN</span>
          </h1>

          <p className="subtitle">
            Save more on every diecast purchase with
            exclusive member benefits.
          </p>

          {currentMembership ? (
            <div className="active-member">
              <div className="member-card">
                <span className="member-tag">
                  ACTIVE MEMBERSHIP
                </span>

                <h2>{currentMembership.name}</h2>

                <p>
                  {currentMembership.expiresOn ===
                    "Lifetime access" ? (
                    <strong className="lifetime">
                      Lifetime access
                    </strong>
                  ) : (
                    <>
                      Valid until{" "}
                      <strong>
                        {currentMembership.expiresOn}
                      </strong>
                    </>
                  )}
                </p>

                {currentMembership.isLifetime && (
                  <p className="lifetime-note">
                    You already have lifetime membership. No upgrade is needed.
                  </p>
                )}
              </div>

              <div className="member-actions">
                <button className="outline-btn">
                  Manage
                </button>
                {!currentMembership.isLifetime && (
                  <button
                    className="select-btn upgrade-btn"
                    onClick={() => navigate("#plans")}
                  >
                    Upgrade Membership
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="no-member">
              <h2>YOUR MEMBERSHIP STATUS</h2>
              <p>
                You don’t have an active membership.
                Choose a plan and start saving today.
              </p>
            </div>
          )}
        </section>

        {/* PLANS */}
        <section
          className="membership-plan-back"
          id="plans"
        >
          <div
            className={`membership-plans ${visiblePlans.length === 1 ? "membership-plans-single" : ""}`}
          >
            {visiblePlans.map((plan) => {
              const isCurrent =
                currentMembership?.name === plan.name;

              return (
                <div
                  key={plan.id}
                  className={`plan-card ${visiblePlans.length === 1 ? "plan-card-single" : ""} ${isCurrent ? "current-plan" : ""
                    }`}
                  style={{
                    borderTopColor: plan.color,
                  }}
                >
                  <h3>{plan.name}</h3>

                  <div className="price">
                    {plan.price}
                    <span
                      className={`period ${!plan.duration ? "lifetime" : ""
                        }`}
                    >
                      {" / "}
                      {formatDuration(plan.duration)}
                    </span>
                  </div>

                  <ul className="benefits-list">
                    {plan.benefits.map((b) => (
                      <li key={b.id}>✓ {b.description}</li>
                    ))}
                  </ul>

                  {isCurrent ? (
                    <button
                      className="current-btn"
                      disabled
                    >
                      Current Plan
                    </button>
                  ) : currentMembership?.isLifetime ? (
                    <button
                      className="select-btn disabled-plan-btn"
                      disabled
                    >
                      Select Plan
                    </button>
                  ) : (
                    <button
                      className="select-btn"
                      onClick={() => {
                        if (!isAuthenticated) {
                          setShowLoginModal(true);
                          return;
                        }

                        navigate(`/membership/request/${plan.id}`);

                      }}
                    >
                      {currentMembership ? "Upgrade" : "Select Plan"}
                    </button>

                  )}
                </div>
              );
            })}
          </div>
        </section>
      </main>
    </div>
  );
};

export default MembershipPage;
